<template>
	<h3 class="text-2xl font-bold">FAQ</h3>
	<h4 class="font-bold text-lg mt-2">
		What is the Server IP for {{ title }}?
	</h4>
	<p class="text-sm mt-2 font-normal">
		The IP for the {{ title }} is:
		<span class="font-bold">{{
				ip + (port ?? "")
			}}</span>
	</p>
	<h4 class="font-bold text-lg mt-3.5">
		What Game modes can I play on {{ title }}?
	</h4>
	<p class="text-sm mt-2 font-normal">
		On {{ title }} you can enjoy the following game modes:
	</p>
	<div class="flex gap-2 flex-wrap mt-2">
		<NuxtLink v-for="tag in tags"
		          :key="`tag-${tag}`"
                  :to="typeof tag === 'string' ? '' : {name: 'tag-page', params: {tag: tag.urlname}}"
		          class="bg-blue-100 px-1 py-0.5 text-sm hover:bg-blue-150"
		>
			<template v-if="typeof tag === 'string'">
				{{ tag }}
			</template>
			<template v-else>
				{{ tag.name }}
			</template>
		</NuxtLink>
	</div>
	<h4 class="font-bold text-lg mt-3.5">
		What versions does the {{ title }} server support?
	</h4>
	<p class="text-sm mt-2 font-normal">
		{{ title }} currently supports versions: {{ version }}
	</p>
</template>

<script setup>
const props = defineProps({
	title: {
		type: String,
		default: '',
	},
	ip: {
		type: String,
		default: '',
	},
	port: {
		type: String,
	},
	version: {
		type: String,
		default: '',
	},
	tags: {
		type: Array,
		default: () => [],
	}
});
</script>